module.exports = __webpack_public_path__ + "static/contact-brush-d61969c0178f59eeffc2e3687743cffc.png";